import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { SapArticleModel } from '../models/sap-article.model';
import { ConfigurationService } from '../shared/services/configuration.service';
import { BuildOrderModel } from '../models/build-order.model';
import { AssemblyAreaModel } from '../models/assembly-area.model';
import { MeasurementUnitsModel } from '../models/measurement-units.model';
import { ItemCategoryModel } from '../models/item-category.model';

@Injectable({
  providedIn: 'root',
})
export class SapArticleService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);

  private backUrl;

  constructor() {
    this.backUrl = `${this.configSvc.manufacturingApiUrl}api`;
  }

  // Articulos
  getAllArticles(): Observable<Array<SapArticleModel>> {
    return this.http.get<Array<SapArticleModel>>(
      `${this.backUrl}/ManufacturingItem`
    );
  }

  getArticleById(artId: Guid): Observable<SapArticleModel> {
    return this.http.get<SapArticleModel>(
      `${this.backUrl}/ManufacturingItem/${artId}`
    );
  }

  getArticleByInterlanCode(artInternalCde: Guid): Observable<SapArticleModel> {
    return this.http.get<SapArticleModel>(
      `${this.backUrl}/ManufacturingItem/InternalCode/${artInternalCde}`
    );
  }

  postArticle(model: SapArticleModel): Observable<any> {
    return this.http.patch(`${this.backUrl}/ManufacturingItem`, model);
  }

  patch(model: SapArticleModel): Observable<any> {
    return this.http.patch(
      `${this.backUrl}/ManufacturingItem/${model.id}`,
      model
    );
  }

  isCumulative(artId: Guid, isCumulative: boolean) {
    return this.http.patch<SapArticleModel>(
      `${this.backUrl}/ManufacturingItem/${artId}/updateIsCumulative`,
      { isCumulative: isCumulative }
    );
  }

  deleteArticle(artId: Guid, isActive: boolean): Observable<SapArticleModel> {
    return this.http.patch<SapArticleModel>(
      `${this.backUrl}/ManufacturingItem/${artId}/updateIsActive`,
      { isActive: isActive }
    );
  }

  getBuildOrder(): Observable<Array<BuildOrderModel>> {
    return this.http.get<Array<BuildOrderModel>>(
      `${this.backUrl}/ManufacturingItem/buildOrders`
    );
  }
  
  getItemCategories(): Observable<Array<ItemCategoryModel>> {
    return this.http.get<Array<ItemCategoryModel>>(
      `${this.backUrl}/ManufacturingItem/itemCategories`
    );
  }

  getAssemblyArea(): Observable<Array<AssemblyAreaModel>> {
    return this.http.get<Array<AssemblyAreaModel>>(
      `${this.backUrl}/ManufacturingItem/assemblyAreas`
    );
  }

  updateInternalCodes(internalCode: string) {
    return this.http.patch(
      `${this.backUrl}/ManufacturingItem/InternalCode/${internalCode}/updateAO`,
      {}
    );
  }

  getTypes(): Observable<any[]> {
    return this.http.get<any[]>(`${this.backUrl}/ManufacturingItem/types`);
  }

  getMeasurementUnits(): Observable<MeasurementUnitsModel[]> {
    return this.http.get<MeasurementUnitsModel[]>(
      `${this.backUrl}/ManufacturingItem/measurementUnits`
    );
  }
}
